export class KontonummerError extends Error {
  name = 'KontonummerError';
}
